/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function LowPoly(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.85753L20.25 7.4412V16.5583L12 21.1409L3.75 16.5583V7.4412L12 2.85753ZM12.6548 1.50534C12.4544 1.39423 12.2291 1.33594 12 1.33594C11.7709 1.33594 11.5456 1.39423 11.3452 1.50534L2.94525 6.17234C2.73503 6.28905 2.55927 6.46007 2.43713 6.6672C2.31489 6.8745 2.25028 7.1107 2.25 7.35134V16.6459C2.24995 16.8868 2.31436 17.1237 2.43656 17.3313C2.55882 17.539 2.73446 17.7102 2.94525 17.8271L11.3448 22.4929C11.5451 22.604 11.7709 22.6625 12 22.6625C12.2291 22.6625 12.4544 22.6042 12.6548 22.4931L21.0548 17.8271C21.2655 17.7102 21.4412 17.539 21.5634 17.3313C21.6856 17.1237 21.7501 16.8871 21.75 16.6462V7.35223C21.7497 7.11158 21.6851 6.87449 21.5629 6.6672C21.4407 6.46007 21.2655 6.28933 21.0553 6.17262L12.6548 1.50534Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.84436 6.91303C2.64322 7.27513 2.7737 7.73172 3.1358 7.93287L11.25 12.4402V20.9992C11.25 21.4134 11.5858 21.7492 12 21.7492C12.4142 21.7492 12.75 21.4134 12.75 20.9992V12.4408L20.8362 7.94886C21.1983 7.74772 21.3288 7.29112 21.1276 6.92902C20.9265 6.56693 20.4699 6.43645 20.1078 6.6376L12.0005 11.1412L3.8642 6.62159C3.5021 6.42045 3.0455 6.55093 2.84436 6.91303Z"
        fill="currentColor"
      />
      <path
        d="M12.309 11.8282L20.109 7.49419C20.2004 7.44352 20.3034 7.41759 20.4078 7.41895C20.5123 7.42031 20.6146 7.44893 20.7046 7.50196C20.7946 7.555 20.8692 7.63061 20.921 7.72133C20.9728 7.81205 21.0001 7.91472 21 8.01919V16.6462C21.0001 16.7533 20.9714 16.8585 20.9171 16.9508C20.8627 17.0431 20.7847 17.1192 20.691 17.1712L12.891 21.5042C12.7996 21.5549 12.6966 21.5808 12.5922 21.5794C12.4877 21.5781 12.3854 21.5495 12.2954 21.4964C12.2054 21.4434 12.1308 21.3678 12.079 21.2771C12.0272 21.1863 11.9999 21.0837 12 20.9792V12.3522C12.0001 12.2452 12.0288 12.1403 12.0832 12.0481C12.1375 11.956 12.2155 11.8801 12.309 11.8282Z"
        fill="currentColor"
      />
    </svg>
  )
}

LowPoly.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default LowPoly
